import styles from "./notesMessage.module.scss";
import ChatLike from "../chatLike";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import ChatNotesInner from "../chatNotesInner";
import React, { useEffect } from "react";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import { chats, initialStateModel } from "../../../../models/model";
import { useSelector } from "react-redux";

type noteMessageProps = {
  data: any;
  searchedData?: any;
  viewData?: any;
  savedData?: any;
  timeValue?:any;
};

export default function ChatNotesMessage({ data, searchedData, viewData, savedData,timeValue }: noteMessageProps) {
  let { id, direction, timestamp, fromcaller_details } = data;
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let timeCount = timeValue !== undefined ? timeValue : 18;
  //const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  //let htimestamp = moment(timestamp).format("hh:mm A");
  let messageBody: any = "";
  if (data?.message?.body) {
    messageBody = data.message.body;
  }
  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
      focusableInputElements[0].focus();
    }
    if (messageBody.deletedId) {
      return;
    }
  }, [savedData]);
  try {
    if (viewData && viewData.message_type_value === "NOTE") {
      viewData = data.message.body;
    }
    const handlehighlightHover = () => {
      var element: HTMLElement | any = document.getElementById(id) || null;
      if (element != null) {
        element.classList.add("highlighthover");
      }
    };

 
  return (
    <>
      {/* <div className={`${styles.chatMsg} ${styles.leftMessage} ${styles.addBookleftMessage}`}> */}
      {
        direction === 'IN'? <div className={`${chatReducer.isSaveChat&&
          id===savedData?'savedhighlight':""
         } 
        ${styles.chatMsg} lftMessage ${styles.leftMessage}`} id={id}>
         {timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
         <ChatUserInfo userDetails = {fromcaller_details ? fromcaller_details : 'Unknown User'} className='userinfoIcon leftSide'/>
            <div className={styles.convMemName}><span>{fromcaller_details ? fromcaller_details?.caller_id : 'Unknown User'}</span></div>
          </div> }
          <div className={`${styles.chatLeftMessages}`}>
            <div className={styles.chatLeft}>
              <div className={`msgContentLft ${styles.chatContent}`}>
                <span className={id===savedData?"focusText":"" }  tabIndex={0}>
                <ChatNotesInner notesData={messageBody} searchedData={searchedData}/></span>
                <span className={styles.notesChatContent}>{fromcaller_details?.first_name}  {data?.message?.isEdit ? " updated the Note":" created a new Note"} </span>
                <ChatLeftInfo userDetails = {fromcaller_details} timeStamp = {timestamp} message={data}></ChatLeftInfo>
                <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}><ChatHoverOption className='hoverList hoverListleft' data={data} highlightHover={handlehighlightHover}/></div>
              </div>
            </div>
          </div>
          <ChatLike className="likeLeft" placement="top" tooltipTitle={data?.likeduserdetails} message={data} />
        </div>:<div className={`${chatReducer.isSaveChat&&
          id===savedData?'savedhighlight':""
         } rtMessage ${styles.chatMsg} ${styles.rightMessage}`} id={id}>
         {timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
            <div className={styles.convMemName}><span>You</span></div>
            <ChatUserInfo userDetails = {fromcaller_details} className='userinfoIcon rightSide'/>
            {/* <URCheckBox className="chatSelectRight"/> */}
          </div>}
          <div className={`${styles.chatRightMessages}`}>
            <div className={styles.chatRight}>
              <div className={`msgContentRT ${styles.chatContent}`}>
                <span className={id===savedData?"focusText":"" }  tabIndex={0}>
                <ChatNotesInner notesData={messageBody} searchedData={searchedData}/></span>
                <span className={styles.notesChatContent}>  {data?.message?.isEdit ? "You updated the Note" : "You created a new Note"}</span>
                <ChatRightInfo userDetails = {fromcaller_details} timeStamp = {timestamp} message={data}></ChatRightInfo>
                <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}><ChatHoverOption className='hoverList hoverListright' data={data} highlightHover={handlehighlightHover}/></div>
              </div>
              
            </div>
          </div>
          <ChatLike
                className="likeRight"
                placement="topRight"
                tooltipTitle={data?.likeduserdetails}
                message={data}
              />
          </div>
        }
      </>
    );
  } catch (e) {
    return <p style={{ color: "red" }}>Something went wrong</p>;
  }
}
